<button #button mat-flat-button (click)="value = !value" [class]="value ? 'cat-btn-selected-button' : 'cat-btn-outline-button'"><ng-content></ng-content></button>

